export const AUGUSTE_BASE_URL = "https://app.auguste.video"

export const AUGUSTE_MODULES = {
  library: {
    url: `${AUGUSTE_BASE_URL}/library`,
    featureCode: "AUGUSTE_LIBRARY",
  },
  publicationCalendar: {
    url: `${AUGUSTE_BASE_URL}/posts`,
    featureCode: "AUGUSTE_PUBLICATION_CALENDAR",
  },
} as const

export function buildAugusteLoginUrl(bearerToken: string): string {
  return `${AUGUSTE_BASE_URL}/login?token=${encodeURIComponent(bearerToken)}`
}
